import { usePage } from "@inertiajs/vue3";
import { computed, ComputedRef } from "vue";

interface AuthProps {
  user: any;
  roles: string[];
}

/**
 * Hook composable pour gérer les autorisations basées sur les rôles
 */
export function useRoles() {
    const page = usePage();
    const roles: ComputedRef<string[]> = computed(() =>
        (page.props.auth as AuthProps)?.roles || []
    );

    return {
        roles,
        hasRole: (role: string): boolean => roles.value.includes(role),
        hasAnyRole: (requiredRoles: string[]): boolean =>
            requiredRoles.some(role => roles.value.includes(role)),
        hasAllRoles: (requiredRoles: string[]): boolean =>
            requiredRoles.every(role => roles.value.includes(role))
    };
}

